import { useNotify, useTranslate } from 'ra-core';
import { useCallback } from 'react';

export const useErrorNotifier = ({ prefix }: { prefix: string }) => {
  const notify = useNotify();
  const t = useTranslate();

  const getTranslatedError = useCallback(
    (error: any): string => {
      const key = (error?.code ?? 'default').split('/')[1].replace(/-/g, '_');

      return t(`${prefix}.${key}`);
    },
    [t, prefix]
  );

  return useCallback(
    (error: any) => {
      notify(getTranslatedError(error), { type: 'error' });
    },
    [notify, getTranslatedError]
  );
};
